module.exports = __webpack_public_path__ + "img/content_title2.0104e334.png";